import React from "react";
import "./CarFormDetail.css";
import { Link } from "react-router-dom";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";

const CarFormDetail = props => (
  <Grid container spacing={3} xs={12} sm={4} style={{ marginLeft: "20px" }}>
    <Grid item xs={12} sm={12}>
      <div className="CarFormBox">
        <div className="CarFormTitle2">Detalle de la Reserva</div>

        <div style={{ fontSize: "0.8rem", marginTop: "15px" }}>
          Vehículo que estas reservando:
        </div>
        <div
          style={{
            width: "100%",
            display: "flex",
            marginTop: "20px"
          }}
        >
          <div
            style={{
              width: "40%"
            }}
          >
            <div
              style={{
                fontFamily: "ToyotaBold",
                fontSize: "1.5rem",
                marginTop: "10px"
              }}
            >
              COROLLA
            </div>
            <div
              style={{
                fontFamily: "ToyotaRegular",
                fontSize: "1.2rem"
              }}
            >
              1.8 Se-g Cvt
            </div>
          </div>
          <div className="FormCarImgDiv">
            <img src="/img/cars/corolla-gray-big.png" className="FormCarImg" />
          </div>
        </div>
      </div>
      <div className="CarFormBox">
        <div style={{ display: "flex" }}>
          <div style={{ width: "70%", fontSize: "0.9rem" }}>
            Valor del Vehiculo
          </div>
          <div style={{ width: "30%", textAlign: "right" }}>$1.200.577</div>
        </div>
        <br />
        <div style={{ display: "flex" }}>
          <div style={{ width: "70%", fontSize: "0.9rem" }}>
            Valor del Patentamiento con Prana
          </div>
          <div style={{ width: "30%", textAlign: "right" }}>$40.000</div>
        </div>
        <br />
        <div className="CarFormLine"></div>
        <div style={{ display: "flex", fontFamily: "ToyotaBold" }}>
          <div style={{ width: "70%", fontSize: "0.9rem" }}>TOTAL</div>
          <div style={{ width: "30%", textAlign: "right" }}>$1.240.577</div>
        </div>
        <div
          style={{
            display: "flex",
            fontFamily: "ToyotaBold",
            backgroundColor: "#ec1c24",
            marginTop: "10px",
            marginLeft: "-10px",
            padding: "10px",
            color: "white",
            marginBottom: "30px"
          }}
        >
          <div style={{ width: "70%", fontSize: "0.9rem" }}>
            MONTO DE RESERVA
          </div>
          <div style={{ width: "30%", textAlign: "right" }}>$5.000</div>
        </div>
      </div>
    </Grid>
  </Grid>
);

export default CarFormDetail;
